import OverviewBanner from "./header/OverviewBanner";
import OverviewContent from "./content/OverviewContent";
const OverviewSection = () => {
  return (
    <section className="overview-section" id="overview">
      <OverviewBanner />
      <OverviewContent />
    </section>
  );
};

export default OverviewSection;
